import { createStore } from 'vuex';
import modules from './modules';

function useStrictMode () {
    return false;
    // return process.env.NODE_ENV !== 'production' && !window.Cypress;
}

function getStore () {
    return createStore({
        modules,
        strict: useStrictMode(),
    });
}

const store = getStore();

export default store;

// Used in Cypress Component Testing
export { getStore };
